import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --toggle-width: 44px;
    --toggle-height: 24px;
    --toggle-bg: var(--color-gray-3);
    --toggle-bg-selected: var(--color-secondary);
    --toggle-bg-disabled: var(--color-gray-2);
    --knob-bg: var(--surface-knob);
    --label-color: var(--base-text-color);
    --label-color-disabled: var(--color-gray-5);
  }

  .toggle-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-md, 16px);
    cursor: pointer;
    user-select: none;
  }

  :host([position="right"]) .toggle-wrapper {
    flex-direction: row-reverse;
  }

  :host([state="disabled"]) .toggle-wrapper,
  .toggle-wrapper[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.7;
  }

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle {
    width: var(--toggle-width);
    height: var(--toggle-height);
    border-radius: calc(var(--toggle-height) / 2);
    position: relative;
    flex: none;
    background: var(--toggle-bg);
    transition: background 0.2s ease-in-out;
  }

  .knob {
    position: absolute;
    width: calc(var(--toggle-height) - 4px);
    height: calc(var(--toggle-height) - 4px);
    top: 2px;
    left: 2px;
    background: var(--knob-bg);
    border-radius: 50%;
    transition: left 0.2s ease-in-out;
  }

  .label, ::slotted([slot="label"]) {
    font-size: var(--font-size-label);
    line-height: var(--line-height-label);
    font-weight: var(--font-weight-regular);
    color: var(--label-color);
  }

  :host([position="right"]) .label,
  :host([position="right"]) ::slotted([slot="label"]) {
    text-align: right;
  }

  :host([state="disabled"]) .label,
  :host([state="disabled"]) ::slotted([slot="label"]) {
    color: var(--label-color-disabled);
  }

  /* States */
  :host([state="default"]:not([checked])) .toggle,
  :host([state="focus"]:not([checked])) .toggle {
    background: var(--toggle-bg);
  }

  :host([state="default"][checked]) .toggle,
  :host([state="selected"][checked]) .toggle {
    background: var(--toggle-bg-selected);
  }

  :host([state="hover"]:not([checked])) .toggle {
    background: var(--color-secondary-light-1, #c3d6e3);
  }

  :host([state="hover"][checked]) .toggle {
    background: var(--color-secondary-light-1, #c3d6e3);
  }

  :host([state="focus"]:not([checked])) .toggle {
    box-shadow: 0 0 0 3px var(--color-secondary, #2594e3);
  }

  :host([state="focus"][checked]) .toggle {
    box-shadow: 0 0 0 3px var(--color-secondary, #2594e3);
  }

  :host([state="disabled"]) .toggle {
    background: var(--toggle-bg-disabled);
  }

  :host([checked]) .knob {
    left: calc(var(--toggle-width) - var(--toggle-height) + 2px);
  }

  :host([state="press"]) .toggle {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    .toggle-wrapper {
      gap: var(--spacing-sm, 8px);
    }
    .toggle {
      width: calc(var(--toggle-width) * 0.9);
      height: calc(var(--toggle-height) * 0.9);
    }
    .knob {
      width: calc(var(--toggle-height) * 0.9 - 4px);
      height: calc(var(--toggle-height) * 0.9 - 4px);
    }
    .label, ::slotted([slot="label"]) {
      font-size: var(--font-size-b3, 14px);
    }
  }
`;